import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import Loader from 'components/Loader'
import { EmployerUserSignupsTable } from 'components/Table/EmployerUserSignupsTable'
import {
  fetchEmployerUserSignupListing,
  fetchApproveEmployerUserSignup,
} from 'src/redux/employerUserSignupApproval'

const EmployerUserSignups = () => {
  const dispatch = useDispatch()
  const { loading, approving, employerUserSignups = [] } = useSelector(
    state => state.employerUserSignupApproval,
  )

  const [confirmSignup, setConfirmSignup] = useState(null)

  useEffect(() => {
    dispatch(fetchEmployerUserSignupListing())
  }, [dispatch])

  const handleApproveClick = signup => {
    setConfirmSignup(signup)
  }

  const handleConfirmApprove = () => {
    dispatch(fetchApproveEmployerUserSignup(confirmSignup.employerUserId))
    setConfirmSignup(null)
  }

  const handleCancelApprove = () => {
    setConfirmSignup(null)
  }

  const tableData = employerUserSignups.map(signup => ({
    employerUserId: signup.employerUserId,
    firstName: signup.firstName,
    lastName: signup.lastName,
    email: signup.email,
    employerName: signup.employerName,
    selfRegisteredAt: new Date(signup.selfRegisteredAt).toDateString(),
    status: signup.approvedAt ? (
      <Chip label='Approved' color='success' size='small' />
    ) : (
      <Chip label='Pending' color='warning' size='small' />
    ),
    actions: signup.approvedAt ? null : (
      <Button
        variant='outlined'
        size='small'
        onClick={() => handleApproveClick(signup)}
        disabled={approving}
      >
        Approve
      </Button>
    ),
  }))

  return (
    <>
      {loading ? <Loader /> : <EmployerUserSignupsTable data={tableData} />}

      <Dialog open={!!confirmSignup} onClose={handleCancelApprove}>
        <DialogTitle>Approve Employer User Signup</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to approve{' '}
            <strong>
              {confirmSignup?.firstName} {confirmSignup?.lastName}
            </strong>{' '}
            ({confirmSignup?.email}) from{' '}
            <strong>{confirmSignup?.employerName}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelApprove}>Cancel</Button>
          <Button variant='contained' onClick={handleConfirmApprove}>
            Approve
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default EmployerUserSignups
